<template>
	<div class="message-checkbox" :class="{ 'checkbox-right': position === 'right' }">
		<el-checkbox
			:value="selected"
			@change="handleChange">
		</el-checkbox>
	</div>
</template>

<script>
export default {
	name: 'MessageCheckbox',
	props: {
		messageId: {
			type: [String, Number],
			required: true
		},
		selected: {
			type: Boolean,
			default: false
		},
		position: {
			type: String,
			default: 'left',
			validator: (value) => ['left', 'right'].includes(value)
		}
	},
	methods: {
		handleChange(value) {
			this.$emit('toggle', this.messageId);
		}
	}
}
</script>

<style scoped>
.message-checkbox {
	position: absolute;
	left: -30px;
	top: 20px; /* 头像高度40px的一半，与头像中线对齐 */
	transform: translateY(-50%);
	z-index: 10;
	transition: all 0.2s ease;
}

.checkbox-right {
	left: auto;
	right: -0px;
}

.message-checkbox >>> .el-checkbox__inner {
	width: 20px;
	height: 20px;
}

.message-checkbox >>> .el-checkbox__inner::after {
	height: 10px;
	left: 6px;
}
</style>
